import React from 'react';
import './index.css';
import App from './App';
import LoginPage from './components/LoginPage';

import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { getCurrentSession } from './cognito-auth';
import { handleAutoLogin } from './auth';

const root = createRoot(document.getElementById('root'));

function renderLoginPage() {
  root.render(
    <LoginPage onLoginSuccess={(userInfo) => renderApp(userInfo)} />
  );
}

function renderApp(userInfo) {
  root.render(
    <Router>
      <Routes>
        <Route path="*" element={<App userInfo={userInfo} onLogout={renderLoginPage} />} />
      </Routes>
    </Router>
  );
}

async function initializeApp() {
  // Show loading screen while checking for an existing session
  root.render(
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#666',
        gap: '20px',
      }}
    >
      <div>Initializing WBC Portal…</div>
      <div style={{ fontSize: '14px', color: '#999' }}>
        Checking authentication status
      </div>
    </div>
  );

  // Try Cognito session first
  try {
    const userInfo = await getCurrentSession();
    renderApp(userInfo);
    return;
  } catch (cognitoError) {
    // Cognito session not found or invalid
  }

  // Try Azure AD session as fallback
  try {
    const azureResult = await handleAutoLogin();
    if (azureResult.success && azureResult.userData) {
      renderApp({ ...azureResult.userData, authType: 'azure' });
      return;
    }
  } catch (azureError) {
    // Azure session not found or invalid
  }

  // No valid session from either provider — show login page
  renderLoginPage();
}

initializeApp();

reportWebVitals();
